"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getStyles = void 0;

var _react = require("@fluentui/react");

var GlobalClassNames = {
  root: 'ms-Card'
};

var getStyles = function getStyles(props) {
  var theme = props.theme;
  var classNames = (0, _react.getGlobalClassNames)(GlobalClassNames, theme);
  return {
    root: [classNames.root, {
      boxShadow: _react.Depths.depth4,
      backgroundColor: theme.semanticColors.bodyBackground
    }]
  };
};

exports.getStyles = getStyles;